import type { ReactNode } from 'react';

export const symbol_pin_road: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M333-120v-143h60v143h-60Zm0-289v-143h60v143h-60Zm0-289v-142h60v142h-60ZM61-120l110-720h59L121-120H61Zm618.5-3.5Q674-127 671-132l-3.97-9q-22.86-48-63.59-82.5Q562.7-258 533.89-302 517-328 508.5-356.5T500-416q0-78 57-130.5T693-599q78 0 132.5 56T880-408q0 29-8 56t-24 50q-29 45-70 78.5t-63 82.34l-4 9.16q-3 5-8.5 8.5T691-120q-6 0-11.5-3.5Zm67-230Q770-377 770-410t-23.5-56.5Q723-490 690-490t-56.5 23.5Q610-443 610-410t23.5 56.5Q657-330 690-330t56.5-23.5ZM531-605l-36-235h60l31 201q-15 6.84-28.5 14.92T531-605Z"
		/>
	</svg>
);
